import type { SVGProps } from "react";
export interface SandwichIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SandwichIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SandwichIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 18a.875.875 0 0 0-.875-.875H5a.875.875 0 0 0 0 1.75h14a.876.876 0 0 0 .875-.875m0-12A.875.875 0 0 0 19 5.125H5a.875.875 0 0 0 0 1.75h14A.876.876 0 0 0 19.875 6m2.25 12A3.126 3.126 0 0 1 19 21.125H5a3.126 3.126 0 0 1 0-6.25h14A3.125 3.125 0 0 1 22.125 18m0-12A3.126 3.126 0 0 1 19 9.125H5a3.126 3.126 0 0 1 0-6.25h14A3.125 3.125 0 0 1 22.125 6M19.5 10.375c.754 0 1.598.221 2.237.775a1.124 1.124 0 0 1-1.474 1.7c-.13-.112-.402-.225-.763-.225s-.633.113-.763.226c-.64.553-1.483.774-2.237.774-.66 0-1.388-.17-1.988-.582l-.249-.192c-.13-.113-.402-.226-.763-.226s-.633.113-.763.226c-.64.553-1.483.774-2.237.774-.66 0-1.388-.17-1.988-.582l-.249-.192c-.13-.113-.402-.226-.763-.226s-.633.113-.763.226c-.64.553-1.483.774-2.237.774-.66 0-1.388-.17-1.988-.582l-.249-.192-.083-.081a1.126 1.126 0 0 1 1.466-1.69l.09.07.124.083c.148.08.37.143.64.143.361 0 .633-.113.763-.226l.25-.192c.599-.413 1.327-.583 1.987-.583.754 0 1.598.221 2.237.775l.123.083c.148.08.37.143.64.143.361 0 .633-.113.763-.226l.25-.192c.599-.413 1.327-.583 1.987-.583.754 0 1.598.221 2.237.775l.123.083c.148.08.37.143.64.143.361 0 .633-.113.763-.226l.25-.192c.599-.413 1.327-.583 1.987-.583"
      />
    </svg>
  );
}
